.root {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  z-index: var(--z-index-modal);
  /* The layer covers the whole screen and paints nothing for the first moments. A boundary that
     never resolves then swallows every click in the app, with no sign of why. */
  pointer-events: none;
}
.panel {
  pointer-events: auto;
  width: 560px;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--color-neutral-white);
  border-radius: var(--border-radius-large);
  border: var(--border-gray-70);
  box-shadow: var(--box-shadow-large);
}
